import { cn, InfoIcon } from "@au-schein-de/au-ui-library";
import type { ComponentProps, ReactNode } from "react";

/**
 * Soft warning banner used inside the pharmacy picker (e.g. the expert-only
 * notice and the "no Top pharmacies near you" courier notice). Cream background
 * with a filled info icon.
 */
export function PharmacyWarningBanner({
	children,
	className,
	...rest
}: { children: ReactNode } & ComponentProps<"div">) {
	return (
		<div
			className={cn(
				"flex items-start gap-2 rounded-lg bg-warning-100 px-3 py-2",
				className,
			)}
			{...rest}
		>
			<span className="shrink-0 mt-0.5">
				<InfoIcon.Filled size={4} colorToken="warning-400" />
			</span>
			<p className="text-body-sm text-gray-700">{children}</p>
		</div>
	);
}
